'use client'

import { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useRouter } from "next/navigation"
import { reportError, useRouterForLink } from "@/(front-desk)/utils/functions"
import { handleCMS } from "@/(front-desk)/store"
import { ArrowRightIcon, ArrowTopRightOnSquareIcon } from "@heroicons/react/20/solid"
import classNames from "classnames"
import Link from "next/link"
import axios from "axios"

export default function exhibit() {

    const dispatch = useDispatch()
    const CMS = useSelector((state) => state.CMS)
    const global = useSelector((state) => state.global)
    const [ activeSection, setActiveSection ] = useState('timeline')
    const sectionAreaRef = useRef()
    const router = useRouter()
    const prefetchedLinks = new Set();

    useEffect(() => {
        if (!CMS.exhibitDescription) {
            axios.get(`/api/v1/cms/zh_hant/posts?category=cms.join_exhibition.description`)
            .then((res) => {
                // console.log('join_exhibition success: ', res.data.body.results[0])
                dispatch(handleCMS.actions.setExhibitDescription(res.data.body.results[0]))
            })
            .catch((err) => {
                // console.log(err.config?.url, err)
                reportError(err, true)
            })
        }
    }, [])

    useEffect(() => {
        if (CMS.exhibitDescription?.contents?.abstract) {
            const aEls = document.getElementById("section-content").querySelectorAll('a');
            useRouterForLink(aEls, prefetchedLinks, router)
        }
    }, [CMS.exhibitDescription])

    return (
        <>
        <title>參展專區 - 放視大賞</title>
        <main className="exhibit">
            <div className="page-banner">
                <div className="page-banner-content">
                    {/* <div className="year leading-[100%]">{global.currentExhibitYear}</div> */}
                    <h1 className="title">Exhibition</h1>
                    {/* <h2 className="sub-title mb-12">{global.currentExhibitYear} 放視大賞 ＊ 參展專區</h2> */}
                    <h2 className="sub-title mb-12">報名參展</h2>
                    <div className="flex flex-wrap gap-4">
                        <a
                            className="btn btn-main btn-round"
                            href={CMS.exhibitDescription && CMS.exhibitDescription.contents.target_link ? CMS.exhibitDescription.contents.target_link : '/user/exhibit'}
                            target="_blank"
                            title="另開新視窗前往放視大賞參展報名"
                        >前往報名 <ArrowTopRightOnSquareIcon className="w-5" /></a>
                        <Link className="btn btn-white btn-round" href="/download/procedure">
                            下載參展作業須知
                        </Link>
                    </div>
                </div>
            </div>
            { CMS.exhibitDescription &&
                <div id="main" className="content pt-10 pb-28">
                    <div className="category-group mb-10">
                        <div className="scroll">
                            <button className="btn active">
                                參展辦法
                            </button>
                        </div>
                    </div>
                    <div className="bottom-area">
                        <div className="guideline active">
                            <div className="side-bar">
                                { CMS.exhibitDescription.contents.meta &&
                                  CMS.exhibitDescription.contents.meta.toc.map((sectionInfo, index) => {
                                    const handleActiveSection = () => {
                                        setActiveSection(sectionInfo.id)
                                        // sectionAreaRef.current.querySelector(`#${sectionInfo.id}`).scrollIntoView({behavior: "smooth"})
                                        const element = sectionAreaRef.current.querySelector(`#${sectionInfo.id}`)
                                        const positionY = element.getBoundingClientRect().top + window.scrollY - 100
                                        window.scrollTo({top: positionY, behavior: 'smooth'})
                                    }
                                    const btnClass = classNames('btn', {
                                        'active': activeSection === sectionInfo.id
                                    })
                                    const button = 
                                        <button
                                            key={`btn-${index}`}
                                            className={btnClass}
                                            onClick={handleActiveSection}
                                        >{sectionInfo.text}</button>
                                    return button
                                })}
                            </div>
                            <div className="section-area" ref={sectionAreaRef}>
                                <div id="section-content" className="mb-8" dangerouslySetInnerHTML={{__html: CMS.exhibitDescription.contents.abstract}}></div>
                                <Link
                                    className="btn btn-main btn-round w-fit"
                                    href={CMS.exhibitDescription.contents.target_link ? CMS.exhibitDescription.contents.target_link : '/user/login'}
                                >前往申請 <ArrowRightIcon className="w-5" /></Link>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </main>
        </>
    )
}
